import { axiosClient } from '@nx-frontend/shared/api';
import { generalEnv } from '@nx-frontend/shared/env';
import { NoteDto } from '@nx-frontend/shared/types';
import { generateNoteGlobalId } from '@nx-frontend/shared/utils';

interface createPortalNoteParams {
  workspaceId: string;
  portalId: string;
  noteName?: string;
  parentId?: string;
  globalId?: string | null;
}

export async function createPortalNote({
  workspaceId,
  portalId,
  noteName = 'New page',
  parentId = 'default',
  globalId = null,
}: createPortalNoteParams): Promise<NoteDto> {
  const note = (
    await axiosClient.post<NoteDto>(
      `${generalEnv.nextApiPath}/workspaces/${workspaceId}/portal/${portalId}/notes/create`,
      {
        workspaceId,
        portalId,
        noteId: globalId ?? generateNoteGlobalId(),
        note: {
          textVersion: 2,
          title: noteName,
          parentId,
          is_portal_share: true,
        },
      }
    )
  ).data;
  return note;
}
